import React from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { ServicesCart } from '@components/templates';

export function ServicesCartPage() {
    const { serviceUuid } = useParams();
    const { t } = useTranslation();

    const translations = {
        title: t('services-cart-component.metatags.title'),
        description: t('services-cart-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.servicesCart.replace(':serviceUuid', `${serviceUuid}`),
        index: false,
    });

    return <ServicesCart />;
}
